export interface Suggestion {
  icon: string;
  label: string;
  prompt: string | ((ctx: { tenant: string }) => string);
  autoSubmit?: boolean;
  hideForAiAdv?: boolean;
}

export const COMMON_SUGGESTIONS: Suggestion[] = [
  {
    icon: "pi pi-search",
    label: "Browse lessons by topic",
    prompt:
      "Show me SQL injection lessons, including hands-on interactive sandbox and video lessons. Include CWE tags, difficulty, and supported languages.",
    hideForAiAdv: true,
  },
  {
    icon: "pi pi-user",
    label: "Learner profile",
    prompt:
      "Pull up the profile for {{<name or email>}} their role, department, coding experience, preferred languages, and which tenants they belong to.",
    autoSubmit: false,
  },
  {
    icon: "pi pi-book",
    label: "Recommend a learning path",
    prompt:
      "Recommend a learning path for an advanced Java developer. Show the path name, lesson count, and difficulty.",
    hideForAiAdv: true,
  },
];

export function resolvePrompt(
  prompt: Suggestion["prompt"],
  ctx: { tenant: string }
): { text: string; selection?: [number, number] } {
  const raw = typeof prompt === "function" ? prompt(ctx) : prompt;
  const match = /\{\{(.+?)\}\}/.exec(raw);
  if (!match) return { text: raw };
  const capture = match[1]!;
  const start = match.index;
  const end = start + capture.length;
  return { text: raw.replace(/\{\{(.+?)\}\}/, capture), selection: [start, end] };
}
